<script lang="ts" setup name="OrganisationHomeTheYourShipmentCount">
import BaseCircle from '~/components/BaseCircle.vue';

defineProps<{
  count: number;
  label: string;
}>();
</script>

<template>
  <BaseCircle
    class="mr-2"
    size="md"
    color="primary"
    background="filled"
    :number="count"
  />

  {{ label }}
</template>
